import React from 'react';
import styled from 'styled-components';

const StyledSvg = styled.svg`
  fill: currentcolor;
  width: 1rem;
`;

export const ArrowDown = props => (
  <StyledSvg viewBox="0 0 10 6" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5 3.2L1.8 0 .4 1.4 5 6l4.6-4.6L8.2 0z" />
  </StyledSvg>
);

export const ArrowLeft = props => (
  <StyledSvg viewBox="0 0 6 10" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2.8 5L6 1.8 4.6.4 0 5l4.6 4.6L6 8.2z" />
  </StyledSvg>
);

export const ArrowRight = props => (
  <svg viewBox="0 0 6 10" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3.2 5L0 8.2l1.4 1.4L6 5 1.4.4 0 1.8z" />
  </svg>
);

export const ArrowUp = props => (
  <StyledSvg viewBox="0 0 10 6" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m5 2.83 3.17 3.17 1.41-1.41-4.58-4.59-4.59 4.59 1.42 1.41z" />
  </StyledSvg>
);

export const Success = props => (
  <StyledSvg
    viewBox="0 0 142 164"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill="none">
      <circle cx="70.83" cy="70.83" r="70.83" fill="#3688A5" />
      <path
        fill="#FFF"
        d="M56.22 108.12L28.78 80.68c-1.899-1.897-2.641-4.663-1.948-7.256.694-2.593 2.718-4.62 5.31-5.315 2.592-.696 5.36.044 7.258 1.941l16.82 16.81 48-48c2.933-2.935 7.69-2.938 10.625-.005 2.935 2.933 2.938 7.69.005 10.625l-58.63 58.64z"
      />
      <ellipse
        cx="70.83"
        cy="157.47"
        fill="#87B2B9"
        opacity=".3"
        rx="52.04"
        ry="6.08"
      />
    </g>
  </StyledSvg>
);

export const Logo = props => (
  <StyledSvg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 200 109"
    {...props}
  >
    <defs />
    <g fill="none">
      <g>
        <path fill="#e4592a" d="M134 66.3h1.5l.9 42.7h-3.2z" />
        <path
          fill="#26335b"
          d="M163.1 90.6h5.2v10.3a19.6 19.6 0 01-10.8 3.5 14 14 0 01-12.3-6.7 13.8 13.8 0 01-1.8-7c0-2.5.6-4.8 1.9-6.9s3-3.7 5.2-4.9 4.6-1.8 7.3-1.8a16.6 16.6 0 0110.6 4l-3.4 4.3a11 11 0 00-7.2-3c-1.5 0-2.9.4-4.2 1.1s-2.3 1.7-3 3a8.8 8.8 0 000 8.5 8.1 8.1 0 009.7 3.8c.9-.3 1.8-.6 2.6-1.1v-7.1zM193 78.9c2.2 1.2 3.9 2.8 5.1 4.9s1.9 4.4 1.9 6.9-.6 4.9-1.9 6.9c-1.2 2.1-2.9 3.7-5.1 4.9s-4.6 1.8-7.2 1.8-5-.6-7.2-1.8-3.9-2.8-5.1-4.9a13.8 13.8 0 010-13.9c1.2-2.1 2.9-3.7 5.1-4.9a14.8 14.8 0 0114.4.1m-11.2 4.5a7.9 7.9 0 00-3 3 8.8 8.8 0 000 8.5 8.1 8.1 0 007.1 4.2 7.7 7.7 0 006.9-4.2 8.9 8.9 0 000-8.5 8 8 0 00-11-3M0 78.7h3.2v23.9H0zm12 .1l.5.4 13.9 18-.1-.8V78.7H29v23.9h-1.6l-.6-.1-.5-.4L12.4 84l.1.8v17.7H9.6V78.7h1.7l.7.1m25.2 0l.5.4 13.9 18-.1-.8V78.7h2.8v23.9h-1.6l-.6-.1-.5-.4L37.7 84l.1.8v17.7H35V78.7h1.7l.5.1m45.2 11.9a13 13 0 01-3.3 8.8c-1 1.1-2.3 1.9-3.7 2.5-1.5.6-3.1.9-4.8.9-1.8 0-3.4-.3-4.8-.9a10.5 10.5 0 01-6.1-6.4c-.6-1.5-.9-3.1-.9-4.9a13 13 0 013.3-8.8c1-1.1 2.3-1.9 3.7-2.5s3-.9 4.8-.9 3.4.3 4.8.9c1.5.6 2.7 1.4 3.7 2.5a12.8 12.8 0 013.3 8.8m-3.4 0c0-1.5-.2-2.8-.6-4s-1-2.2-1.7-3-1.6-1.4-2.7-1.9c-1-.4-2.2-.7-3.5-.7a8.1 8.1 0 00-7.9 5.6c-.4 1.2-.6 2.5-.6 4s.2 2.8.6 3.9c.4 1.2 1 2.1 1.7 3a7.7 7.7 0 006.2 2.5c1.3 0 2.5-.2 3.5-.6s1.9-1 2.7-1.9c.7-.8 1.3-1.8 1.7-3s.6-2.5.6-3.9m4.1-12h2.6l.7.2c.2.1.3.3.4.6l6.8 16.9.4 1.2.4 1.4.3-1.4.4-1.2 6.7-16.9.4-.5c.2-.2.4-.2.7-.2h2.6l-9.7 23.9h-2.9zm42.9 23.9h-2.5l-.7-.2c-.2-.1-.3-.3-.4-.6l-2.2-5.8h-10.7l-2.2 5.8-.4.5c-.2.2-.4.2-.7.2h-2.5l9.6-23.9h3.3zm-15.6-8.9h8.9l-3.8-9.7-.7-2.3a5 5 0 01-.4 1.3l-.3 1z"
        />
        <path
          fill="#e4592a"
          d="M118.9 15.8a22.7 22.7 0 0012.4 38.5l.1-3a19.7 19.7 0 1117.4-33.2 19.7 19.7 0 01-10.4 33.1l.1 3a22.6 22.6 0 10-19.6-38.4z"
        />
        <path
          fill="#f3a81d"
          d="M138 32.1l.4 19.2A19.6 19.6 0 10121 18a19.6 19.6 0 0010.4 33.4l.4-19.2z"
        />
      </g>
      <path d="M141.5 26.1h-13.3v28.5h3.2v-.3c-1.8-.3-3.1-.7-3.1-.7l1.9-27.3 9.4-.1 1.8 27.5s-1.1.4-3 .7v.3l-.4.1h3.4z" />
      <path
        fill="#fff"
        d="M131.4 51.3l.4-19.2 6.2-.1.4 19.2.1 3c1.8-.3 3-.7 3-.7L139.7 26l-9.4.1-1.9 27.3s1.3.4 3.1.7z"
        opacity=".3"
      />
      <path
        fill="#e4592a"
        d="M134.9 30h-2.6c-.5 1.9-.9 3.9-.9 6 0 4.5 1.4 8.7 3.5 12.1a22 22 0 002.5-18.1h-2.5"
      />
      <path
        fill="#f3a81d"
        d="M134.9 31h-1.6a13.2 13.2 0 001.6 11.1 14 14 0 001.6-11.1z"
      />
      <path fill="#171d3c" d="M134.9 29.5L120.7 38l14.2-21.3L149 38.1z" />
      <path
        fill="#d6d8d3"
        d="M134.9 32.1h4.4A38.7 38.7 0 00134.9 1a38.7 38.7 0 00-4.4 31.1h4.4"
      />
      <path
        fill="#26335b"
        d="M134.8 7.3l3.3.2c-.9-2.3-2-4.5-3.3-6.6a36 36 0 00-3.3 6.5l3.3-.1m2.5 4.7c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5 2.5 1.2 2.5 2.5"
      />
      <path
        fill="#fff"
        d="M136.5 12c0 .9-.8 1.7-1.7 1.7s-1.7-.8-1.7-1.7.8-1.7 1.7-1.7c1 0 1.7.8 1.7 1.7"
      />
      <path
        fill="#26335b"
        d="M134.9 22l-5.9.1c0 3.5.5 6.9 1.4 10.2l4.5-.2 4.5.2c.9-3.2 1.4-6.6 1.4-10.1-1.9-.2-3.9-.2-5.9-.2"
      />
    </g>
  </StyledSvg>
);

export const LogoBackoffice = props => (
  <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 170 47" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M138.644 34.167h4.42v8.863a14.661 14.661 0 01-4.335 2.151c-1.7.517-3.23.86-4.845.86-2.21 0-4.25-.515-6.12-1.548-1.785-1.033-3.23-2.41-4.336-4.216-1.02-1.807-1.53-3.786-1.53-6.024 0-2.15.51-4.13 1.615-5.937 1.105-1.807 2.55-3.183 4.42-4.216 1.87-1.033 3.911-1.549 6.206-1.549 1.7 0 3.315.344 4.93.947 1.616.602 2.976 1.462 4.08 2.495l-2.89 3.7c-.85-.774-1.785-1.463-2.89-1.893-1.105-.43-2.21-.688-3.23-.688-1.275 0-2.465.344-3.57.946a6.184 6.184 0 00-2.55 2.582c-.595 1.118-.935 2.323-.935 3.613a7.7 7.7 0 00.935 3.7c.595 1.12 1.445 1.98 2.55 2.668 1.105.602 2.295.946 3.57.946.68 0 1.36-.086 2.125-.344.765-.258 1.53-.516 2.21-.946v-6.11h.17zM164.061 24.1c1.87 1.033 3.315 2.41 4.335 4.216 1.02 1.807 1.616 3.786 1.616 5.937 0 2.152-.51 4.217-1.616 5.938-1.02 1.807-2.465 3.183-4.335 4.216-1.87 1.033-3.91 1.549-6.12 1.549s-4.25-.516-6.12-1.549-3.316-2.41-4.336-4.216c-1.02-1.807-1.615-3.786-1.615-6.024 0-2.15.51-4.13 1.615-5.937 1.02-1.807 2.465-3.183 4.335-4.216 1.87-1.033 3.91-1.549 6.12-1.549 2.296.086 4.336.602 6.121 1.635m-9.52 3.872c-1.106.602-1.956 1.549-2.55 2.581-.596 1.12-.936 2.324-.936 3.614a7.7 7.7 0 00.935 3.7c.595 1.119 1.445 1.98 2.55 2.668 1.02.688 2.21.946 3.486.946 1.275 0 2.38-.344 3.4-.946s1.87-1.549 2.465-2.668a7.7 7.7 0 00.935-3.7c0-1.29-.34-2.495-.935-3.614a6.52 6.52 0 00-2.465-2.58 6.752 6.752 0 00-3.4-.947c-1.275 0-2.38.344-3.485.946" />
        <g>
          <path d="M0 23.928h2.72v20.565H0zM10.2 24.014c.086.086.256.172.426.344l11.816 15.489c0-.259-.085-.517-.085-.689v-15.23h2.295v20.565h-1.36c-.255 0-.425 0-.51-.086-.17-.086-.255-.172-.425-.344L10.54 28.488c0 .259 0 .517.085.689v15.23H8.16v-20.48h1.445c.255 0 .425 0 .595.087M31.622 24.014c.085.086.255.172.425.344l11.816 15.489c0-.259-.085-.517-.085-.689v-15.23h2.38v20.565h-1.36c-.255 0-.425 0-.51-.086-.17-.086-.255-.172-.425-.344L32.047 28.488c0 .259 0 .517.085.689v15.23h-2.38v-20.48h1.445c.085 0 .34 0 .425.087M70.045 34.253c0 1.55-.255 2.926-.765 4.217-.51 1.29-1.19 2.41-2.04 3.356-.85.946-1.956 1.634-3.146 2.15a10.768 10.768 0 01-4.08.775c-1.53 0-2.89-.258-4.08-.774-1.19-.517-2.295-1.205-3.145-2.151-.85-.947-1.53-2.066-2.04-3.356s-.766-2.668-.766-4.217c0-1.548.255-2.925.765-4.216.51-1.29 1.19-2.41 2.04-3.356.85-.946 1.956-1.634 3.146-2.15 1.19-.517 2.55-.775 4.08-.775 1.53 0 2.89.258 4.08.774 1.275.517 2.296 1.205 3.146 2.151.85.947 1.53 2.066 2.04 3.356.51 1.205.765 2.668.765 4.216m-2.89 0c0-1.29-.17-2.409-.51-3.441a7.527 7.527 0 00-1.446-2.582c-.595-.688-1.36-1.204-2.295-1.635a7.975 7.975 0 00-2.975-.602c-1.105 0-2.04.172-2.975.602-.85.345-1.615.947-2.295 1.635a7.527 7.527 0 00-1.445 2.582c-.34 1.032-.51 2.15-.51 3.441s.17 2.41.51 3.356c.34 1.033.85 1.807 1.445 2.582.595.688 1.36 1.204 2.295 1.635.85.344 1.87.516 2.975.516s2.125-.172 2.975-.516A5.973 5.973 0 0065.2 40.19a7.527 7.527 0 001.446-2.582c.34-1.032.51-2.15.51-3.356M70.64 23.928h2.21c.255 0 .425.086.595.172.17.086.255.258.34.516l5.78 14.542c.17.344.255.689.34 1.033.085.344.255.774.34 1.204.085-.43.17-.774.255-1.204.085-.344.255-.775.34-1.033l5.696-14.542c.085-.172.17-.344.34-.43.17-.172.34-.172.595-.172h2.21l-8.245 20.565H78.97l-8.33-20.651zM107.107 44.493h-2.125c-.255 0-.425-.086-.595-.172-.17-.086-.255-.258-.34-.516l-1.87-4.991H93.08l-1.87 4.99c-.085.173-.17.345-.34.43-.17.173-.34.173-.595.173h-2.125l8.16-20.565h2.806l7.99 20.651zm-13.26-7.658h7.565l-3.23-8.347c-.17-.516-.425-1.204-.595-1.979-.085.43-.17.775-.34 1.119-.085.344-.17.602-.255.86l-3.146 8.347z" />
        </g>
      </g>
      <text
        fontFamily="Montserrat-Regular, Montserrat"
        fontSize="14"
        fill="currentcolor"
        transform="translate(0 -4)"
      >
        <tspan x="36.454" y="14">
          BACK-OFFICE
        </tspan>
      </text>
    </g>
  </StyledSvg>
);

export const Options = props => (
  <StyledSvg
    viewBox="0 -128 350.9 350"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M350.9 47.6a47.2 47.2 0 11-94.3 0 47.2 47.2 0 0194.3 0zm0 0M222.6 47.6a47.2 47.2 0 11-94.3 0 47.2 47.2 0 0194.3 0zm0 0M94.3 47.6a47.2 47.2 0 11-94.3 0 47.2 47.2 0 0194.3 0zm0 0" />
  </StyledSvg>
);

export const SuccessStatus = props => (
  <StyledSvg
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
  </StyledSvg>
);

export const Eye = props => (
  <StyledSvg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 576 512"
    {...props}
  >
    <path d="M572.5 241.4C518.3 135.6 411 64 288 64S57.7 135.6 3.5 241.4a32.4 32.4 0 000 29.2C57.7 376.4 165 448 288 448s230.3-71.6 284.5-177.4a32.4 32.4 0 000-29.2zM288 400a144 144 0 11144-144 144 144 0 01-144 144zm0-240a95.3 95.3 0 00-25.3 3.8 47.9 47.9 0 01-67 66.9A95.8 95.8 0 10288 160z" />
  </StyledSvg>
);

export const EyeSlash = props => (
  <StyledSvg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 512"
    {...props}
  >
    <path d="M320 400a143.5 143.5 0 01-142.9-133.1l-104.9-81a333.3 333.3 0 00-36.7 55.5 32.4 32.4 0 000 29.2C89.7 376.4 197 448 320 448c27 0 52.9-4 77.9-10.5L346 397.4a144.1 144.1 0 01-26 2.6zm313.8 58.1l-110.5-85.4a331.3 331.3 0 0081.2-102.1 32.4 32.4 0 000-29.2C550.3 135.6 443 64 320 64a308.1 308.1 0 00-147.3 37.7L45.5 3.4A16 16 0 0023 6.2L3.4 31.5a16 16 0 002.8 22.4l588.3 454.7a16 16 0 0022.5-2.8l19.6-25.3a16 16 0 00-2.8-22.4zm-183.7-142l-39.3-30.4A94.8 94.8 0 00416 256a94.8 94.8 0 00-121.3-92.2A47.6 47.6 0 01304 192a46.6 46.6 0 01-1.5 10l-73.7-56.9A142.3 142.3 0 01320 112a144 144 0 01144 144c0 21.6-5.3 41.8-13.9 60.1z" />
  </StyledSvg>
);

export const Download = props => (
  <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 17" {...props}>
    <path
      d="M14 6h-4V0H4v6H0l7 7zM0 15v2h14v-2z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </StyledSvg>
);

export const Close = props => (
  <StyledSvg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 352 512"
    {...props}
  >
    <path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path>
  </StyledSvg>
);

export const Close2 = props => (
  <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g fill="none" fillRule="evenodd" transform="translate(5 5)">
      <mask id="b" fill="#fff">
        <path
          id="a"
          d="M14 1.41L12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7z"
        />
      </mask>
      <g fill="currentColor" mask="url(#b)">
        <path d="M-18-18h50v50h-50z" />
      </g>
    </g>
  </StyledSvg>
);

export const Search = props => (
  <StyledSvg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    {...props}
  >
    <path d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z" />
  </StyledSvg>
);

export const Linkedin = props => (
  <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <path
      d="M30.694 0H1.306C.585 0 0 .585 0 1.306v29.388C0 31.415.585 32 1.306 32h29.388c.721 0 1.306-.585 1.306-1.306V1.306C32 .585 31.415 0 30.694 0zM9.49 27.268H4.744v-15.27H9.49v15.27zM7.118 9.909a2.752 2.752 0 110-5.505 2.752 2.752 0 010 5.505zm20.15 17.359h-4.743v-7.426c0-1.772-.033-4.05-2.467-4.05-2.47 0-2.848 1.93-2.848 3.921v7.555h-4.743v-15.27h4.553v2.086h.063c.634-1.201 2.182-2.467 4.491-2.467 4.806 0 5.694 3.163 5.694 7.274v8.377z"
      fill="#FFF"
      fillRule="nonzero"
    />
  </StyledSvg>
);

export const Facebook = props => (
  <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <path
      d="M30.222 0H1.778C.796 0 0 .796 0 1.778v28.444C0 31.204.796 32 1.778 32h15.315V19.627h-4.155v-4.845h4.155v-3.555c0-4.134 2.525-6.383 6.223-6.383 1.244-.003 2.487.06 3.724.192v4.297h-2.56c-2 0-2.387.951-2.387 2.351v3.085h4.796l-.622 4.844h-4.174V32h8.13c.981 0 1.777-.796 1.777-1.778V1.778C32 .796 31.204 0 30.222 0z"
      fill="#FFF"
      fillRule="nonzero"
    />
  </StyledSvg>
);

export const Home = props => (
  <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" {...props}>
    <path
      d="M33.12,21.69a3,3,0,0,0-.67.09l-4.06-6.46a2.89,2.89,0,1,0-5.21-1.69s0,.08,0,.12L20.13,15a2.85,2.85,0,0,0-2.13-1,2.79,2.79,0,0,0-1.54.46l-3.57-3a3,3,0,0,0,.18-1A2.85,2.85,0,0,0,8.71,8.07L5.56,5.45a3.05,3.05,0,0,0,.2-1,2.88,2.88,0,1,0-2.88,2.9A2.84,2.84,0,0,0,4.4,6.87L7.52,9.48a2.9,2.9,0,0,0,2.67,4A2.85,2.85,0,0,0,11.74,13l3.57,3a2.83,2.83,0,0,0-.19,1,2.89,2.89,0,0,0,1.47,2.52l-.52,3.88a2.9,2.9,0,0,0,.46,5.76,2.84,2.84,0,0,0,1.74-.6l3.43,2.29a3.17,3.17,0,0,0-.11.76,2.88,2.88,0,1,0,5.76,0,2.93,2.93,0,0,0-.18-1L31.55,27a2.83,2.83,0,0,0,1.57.48,2.91,2.91,0,0,0,0-5.82Zm-9.27-6.22a2.82,2.82,0,0,0,2.21,1.07,2.71,2.71,0,0,0,.85-.15l4,6.37a3,3,0,0,0-.66,1.84,2.84,2.84,0,0,0,.18,1L26,29.16a2.82,2.82,0,0,0-1.57-.47,2.89,2.89,0,0,0-1.75.6L19.3,27a3.33,3.33,0,0,0,.11-.77,2.89,2.89,0,0,0-1.54-2.56l.51-3.83A2.89,2.89,0,0,0,20.88,17c0-.08,0-.16,0-.24Z"
      fill="currentcolor"
    />
  </StyledSvg>
);

export const Processes = props => (
  <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" {...props}>
    <path
      fill="currentcolor"
      d="M16.53,29.9h-2.1l-.71-1.64a2.24,2.24,0,0,0-1.38-1.33V20a2.7,2.7,0,1,0-1.06,0v7a2.27,2.27,0,0,0-1.4,1.33l-.7,1.64H7.08V34H5.5v2H18.11V34H16.53Z"
    />
    <path
      fill="currentcolor"
      d="M25.46,17V9l1.68-.41.94-3.66L25.25,2.14l-3.78.91-.29,1.12h-9L7.92,0,7.39.51C5.54,2.3,5.05,8.4,8.19,14.06a4.85,4.85,0,1,1,6.7,7,19.9,19.9,0,0,0,9.94,2.76c2.31,0,4.2-.51,5.14-1.43l.53-.51ZM13.59,5.49h7.25l-.32,1.22,2.84,2.75.73-.18v6.38Z"
    />
  </StyledSvg>
);

export const Pdf = props => (
  <StyledSvg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 384 512"
    {...props}
  >
    <path
      fill="currentColor"
      d="M181.9 256.1c-5-16-4.9-46.9-2-46.9 8.4 0 7.6 36.9 2 46.9zm-1.7 47.2c-7.7 20.2-17.3 43.3-28.4 62.7 18.3-7 39-17.2 62.9-21.9-12.7-9.6-24.9-23.4-34.5-40.8zM86.1 428.1c0 .8 13.2-5.4 34.9-40.2-6.7 6.3-29.1 24.5-34.9 40.2zM248 160h136v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24zm-8 171.8c-20-12.2-33.3-29-42.7-53.8 4.5-18.5 11.6-46.6 6.2-64.2-4.7-29.4-42.4-26.5-47.8-6.8-5 18.3-.4 44.1 8.1 77-11.6 27.6-28.7 64.6-40.8 85.8-.1 0-.1.1-.2.1-27.1 13.9-73.6 44.5-54.5 68 5.6 6.9 16 10 21.5 10 17.9 0 35.7-18 61.1-61.8 25.8-8.5 54.1-19.1 79-23.2 21.7 11.8 47.1 19.5 64 19.5 29.2 0 31.2-32 19.7-43.4-13.9-13.6-54.3-9.7-73.6-7.2zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-74.1 255.3c4.1-2.7-2.5-11.9-42.8-9 37.1 15.8 42.8 9 42.8 9z"
    />
  </StyledSvg>
);

export const Youtube = props => (
  <StyledSvg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    {...props}
  >
    <path
      fill="currentColor"
      d="M186.8 202.1l95.2 54.1-95.2 54.1V202.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-42 176.3s0-59.6-7.6-88.2c-4.2-15.8-16.5-28.2-32.2-32.4C337.9 128 224 128 224 128s-113.9 0-142.2 7.7c-15.7 4.2-28 16.6-32.2 32.4-7.6 28.5-7.6 88.2-7.6 88.2s0 59.6 7.6 88.2c4.2 15.8 16.5 27.7 32.2 31.9C110.1 384 224 384 224 384s113.9 0 142.2-7.7c15.7-4.2 28-16.1 32.2-31.9 7.6-28.5 7.6-88.1 7.6-88.1z"
    />
  </StyledSvg>
);

export const Trainings = props => (
  <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" {...props}>
    <ellipse cx="17.3" cy="18" rx="4.81" ry="4.86" />
    <path
      fill="currentcolor"
      d="M34.47,20.11A18.23,18.23,0,0,0,34.61,18,17.42,17.42,0,0,0,17.3.5,17.53,17.53,0,0,0,2.15,26.44a3.28,3.28,0,0,0-.58,1.86,3.19,3.19,0,0,0,4.48,3A17.12,17.12,0,0,0,17.3,35.5a17.32,17.32,0,0,0,15.34-9.41h.16a3.24,3.24,0,0,0,1.67-6ZM17.3,33.34a15,15,0,0,1-9.69-3.56A3.34,3.34,0,0,0,8,28.3a3.23,3.23,0,0,0-3.21-3.24,3.09,3.09,0,0,0-.86.13A15.37,15.37,0,0,1,17.3,2.66,15.27,15.27,0,0,1,32.47,18a15.11,15.11,0,0,1-.09,1.66,3.23,3.23,0,0,0-1.72,5.6A15.15,15.15,0,0,1,17.3,33.34Z"
    />
    <path
      fill="currentcolor"
      d="M17.3,6.33a11.41,11.41,0,0,0-4.63,1,3.17,3.17,0,0,0-1.93-.66A3.22,3.22,0,0,0,7.54,9.9a3.18,3.18,0,0,0,.33,1.41A11.68,11.68,0,0,0,17.3,29.67a11.67,11.67,0,0,0,0-23.34Zm0,21.18A9.47,9.47,0,0,1,7.9,18a9.58,9.58,0,0,1,1.52-5.16,3.08,3.08,0,0,0,1.32.3A3.23,3.23,0,0,0,14,9.9a3.47,3.47,0,0,0-.09-.73,9.21,9.21,0,0,1,3.44-.68,9.51,9.51,0,0,1,0,19Z"
    />
  </StyledSvg>
);

export const Products = props => (
  <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" {...props}>
    <path
      fill="currentcolor"
      d="M25.53,25.29,22.15,15.11l.61.32c.11.05.22.08.42-.1l1.73-3.25a.35.35,0,0,0-.17-.41L16.38,7.3l-1.93,3.78,4.63,2.42-.2.4L15.07,25.29l-2.74,8.28a.58.58,0,0,0,.1.58.7.7,0,0,0,.58.2A.64.64,0,0,0,13.5,34L16,26.26l3.62,1.17v8a.59.59,0,0,0,1.18,0v-8l3.61-1.17L27,34a.68.68,0,0,0,.79.39.6.6,0,0,0,.48-.78Zm-6,.88L16.34,25.1l3.22-9.64Zm1.28,0V15.36L24.06,25Z"
    />
    <path
      fill="currentcolor"
      d="M34.32,15.67l-1.63-.86h-.1a.37.37,0,0,0-.31.18l-2.42,4.73a.35.35,0,0,0,.17.41l1.66.88a.22.22,0,0,0,.15,0,.69.69,0,0,0,.23-.19l2.42-4.74A.33.33,0,0,0,34.32,15.67Z"
    />
    <polygon
      fill="currentcolor"
      points="25.45 12.6 23.89 15.53 29.65 18.54 31.16 15.59 25.45 12.6"
    />
    <path
      fill="currentcolor"
      d="M13.36,11.36l0,0a.5.5,0,0,0,.21-.17l.05-.1.17-.33L15.74,7l.16-.33L16,6.43a.71.71,0,0,0,0-.14A.34.34,0,0,0,15.84,6L4.34,0h-.1a.36.36,0,0,0-.31.18L1.51,4.92a.33.33,0,0,0,.17.4l11.54,6S13.27,11.39,13.36,11.36Z"
    />
  </StyledSvg>
);

export const AddSymbol = props => (
  <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" {...props}>
    <g fill="none" fillRule="evenodd" transform="translate(4 4)">
      <mask id="b" fill="#fff">
        <path
          id="a"
          d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20zm0-2c9.941 0 18-8.059 18-18S29.941 2 20 2 2 10.059 2 20s8.059 18 18 18zm-1-25v6h-6v2h6v6h2v-6h6v-2h-6v-6h-2z"
        />
      </mask>
      <g mask="url(#b)">
        <path fill="currentcolor" d="M-4-4h48v48H-4z" />
      </g>
    </g>
  </StyledSvg>
);

export const Calendar = props => (
  <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 20" {...props}>
    <path
      fill="currentcolor"
      transform="translate(-3 -1)"
      fillRule="evenodd"
      d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
    />
  </StyledSvg>
);

export const Proposals = props => (
  <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" {...props}>
    <path
      fill="currentcolor"
      d="M15.3,15.61,8,22.9l-.85-.84L3.77,23.75l8.48,8.48,1.69-3.39L13.1,28,26.66,14.42a3.59,3.59,0,0,0-5.08-5.08l-5.43,5.43-.85-.85h0v-3.4l.4-.39L8.91,3.34,7.22,5,14,11.82l.1-.1v1.85H12.26l.09-.1L5.57,6.69,3.87,8.38l6.79,6.79.4-.41h3.39Z"
    />
    <path
      fill="currentcolor"
      d="M33.45,9.34,30.53,6.42l.91-.91a2.39,2.39,0,1,0-.85-.84l-.91.9-3-3a4.8,4.8,0,1,0,6.79,6.79ZM31.8,2.6a1.22,1.22,0,0,1,1.7,0,1.2,1.2,0,1,1-1.7,0Z"
    />
    <rect
      fill="currentcolor"
      x="13.6"
      y="-0.56"
      width="2.4"
      height="9.59"
      transform="translate(1.34 11.71) rotate(-45)"
    />
    <rect
      fill="currentcolor"
      x="3.57"
      y="9.47"
      width="2.4"
      height="9.59"
      transform="translate(-8.69 7.55) rotate(-45)"
    />
    <rect
      fill="currentcolor"
      x="30.56"
      y="16.4"
      width="2.4"
      height="9.59"
      transform="translate(-5.69 28.67) rotate(-45)"
    />
    <rect
      fill="currentcolor"
      x="20.53"
      y="26.43"
      width="2.4"
      height="9.59"
      transform="translate(-15.72 24.51) rotate(-45)"
    />
    <polygon
      fill="currentcolor"
      points="25.48 20.7 22.08 20.7 22.08 20.7 21.23 19.86 20.39 20.7 21.23 21.55 21.24 24.94 20.83 25.34 27.62 32.13 29.31 30.43 22.53 23.65 22.43 23.74 22.43 21.9 24.28 21.9 24.18 22 30.96 28.78 32.66 27.09 25.87 20.3 25.48 20.7"
    />
    <path
      fill="currentcolor"
      d="M7.16,28.84a.58.58,0,0,0-.84,0L2.08,33.08a.58.58,0,0,0,0,.84.59.59,0,0,0,.85,0l4.23-4.24A.58.58,0,0,0,7.16,28.84Z"
    />
    <path
      fill="currentcolor"
      d="M9.88,31.8a.6.6,0,0,0-.6-.6.6.6,0,0,0-.6.6v3.6a.56.56,0,0,0,.18.42.59.59,0,0,0,1-.42Z"
    />
    <path
      fill="currentcolor"
      d="M4.2,26.12H.6a.59.59,0,0,0-.42,1,.56.56,0,0,0,.42.17H4.2a.6.6,0,0,0,.6-.6A.6.6,0,0,0,4.2,26.12Z"
    />
  </StyledSvg>
);

export const SendByEmail = props => (
  <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 17" {...props}>
    <g transform="translate(-1 -2)" fill="none" fillRule="evenodd">
      <mask id="b" fill="#fff">
        <path
          id="a"
          d="M1.675 17.5L19.167 10 1.675 2.5l-.008 5.833L14.167 10l-12.5 1.667z"
        />
      </mask>
      <g mask="url(#b)" fill="currentcolor">
        <path d="M-10.833-10.833h41.666v41.666h-41.666v-41.666z" />
      </g>
    </g>
  </StyledSvg>
);

export const Communications = props => (
  <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" {...props}>
    <path
      fill="currentcolor"
      d="M32.2 13L16.36 6l-.18-.08a1 1 0 00-.49-.16c-.45 0-.64.42-.73.62l-.06.13c-.11.25-.27.61-.41 1s-.22.48-.33.75a10.93 10.93 0 01-2.51 3.9 9.58 9.58 0 01-6.1 3.1l-.32.05a.55.55 0 00-.38.28.92.92 0 00.1.8l7.33 15.8a1.41 1.41 0 001.29.81 1.52 1.52 0 00.63-.14h.06A1.45 1.45 0 0015 31L9.46 18.58a7.85 7.85 0 005.18-1.51l9.18 9.2a1.16 1.16 0 00.86.36 1.56 1.56 0 001.09-.49 1.36 1.36 0 00.14-2l-9.21-9.26a7.45 7.45 0 001.52-5l12.71 5.9a1.39 1.39 0 00.57.12 1.46 1.46 0 001.31-.9v-.08a1.53 1.53 0 00.07-1.09 1.34 1.34 0 00-.68-.83z"
    />
    <path
      fill="currentcolor"
      d="M14.3 5.36a.5.5 0 00-.19-.48 6.32 6.32 0 00-3.84-1.29 7.19 7.19 0 00-4 1.23l-.54-.34a1.26 1.26 0 00-.33-1.11 1.32 1.32 0 00-1.83 0 1.29 1.29 0 000 1.83 1.31 1.31 0 00.85.38l.26.68a7.22 7.22 0 00-.86 8 .51.51 0 00.44.26c8.5-.52 10.03-9.07 10.04-9.16z"
    />
  </StyledSvg>
);

export const Menu = props => (
  <StyledSvg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 384.97 384.97"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M12.03 84.212h360.909c6.641 0 12.03-5.39 12.03-12.03 0-6.641-5.39-12.03-12.03-12.03H12.03C5.39 60.152 0 65.541 0 72.182c0 6.641 5.39 12.03 12.03 12.03zM372.939 180.455H12.03c-6.641 0-12.03 5.39-12.03 12.03s5.39 12.03 12.03 12.03h360.909c6.641 0 12.03-5.39 12.03-12.03s-5.389-12.03-12.03-12.03zM372.939 300.758H12.03c-6.641 0-12.03 5.39-12.03 12.03 0 6.641 5.39 12.03 12.03 12.03h360.909c6.641 0 12.03-5.39 12.03-12.03.001-6.641-5.389-12.03-12.03-12.03z"
    />
  </StyledSvg>
);
